import type { SemanaEstadistica } from '@app/shared';

// ciclo-tareas: un bar por semana cerrada, un solo color (marca-primario, magnitud
// por altura) — mark spec: barra angosta, remate redondeado de 4px, valor en la
// punta, semana en el eje X. Sin leyenda: una sola serie, el título ya la nombra.
const ALTO_MAX_PX = 120;
const ALTO_MIN_PX = 4;

interface Props {
  semanas: SemanaEstadistica[];
  titulo: string;
}

export function GraficoSemanal({ semanas, titulo }: Props): JSX.Element {
  return (
    <div role="img" aria-label={titulo} className="flex items-end gap-3 overflow-x-auto pb-1">
      {semanas.map((s) => {
        const alto = Math.max(ALTO_MIN_PX, Math.round((s.porcentajeCumplimiento / 100) * ALTO_MAX_PX));
        return (
          <div key={s.numero} className="flex shrink-0 flex-col items-center gap-1">
            <span className="text-xs font-medium tabular-nums text-text-strong">
              {s.porcentajeCumplimiento}%
            </span>
            <button
              type="button"
              title={`Semana ${s.numero}: ${s.cumplidas}/${s.totalActivas} — ${s.porcentajeCumplimiento}%`}
              aria-label={`Semana ${s.numero}: ${s.porcentajeCumplimiento} por ciento de cumplimiento, ${s.cumplidas} de ${s.totalActivas} tareas`}
              className="w-5 cursor-default rounded-t bg-marca-primario transition-opacity hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-marca-primario"
              style={{ height: `${alto}px` }}
            />
            <span className="text-[11px] text-text-faint">S{s.numero}</span>
          </div>
        );
      })}
    </div>
  );
}
